function loadStaticModules(appConfig) {
  require('/Users/tracy/Desktop/Ezcon/ezproui/node_modules/build-plugin-ice-request/lib/runtime.js').default(
    { appConfig }
  );
}

export default loadStaticModules;
